import { useEffect, useState } from 'react';
import { StringUtils } from '@manifoldxyz/js-ts-utils';
import { identityApi } from '@/api/identity';
import { resolveENSFromBadges } from '@/common/address';
import useMainStore from '@/store/mainStore';

export function useTwitterHandle() {
  const studioInstance = useMainStore((state) => state.studioInstance);
  const [twitterHandle, setTwitterHandle] = useState<string | null>(null);

  useEffect(() => {
    const fetchTwitterHandle = async () => {
      const handle = await identityApi.getTwitterHandle(
        studioInstance?.creator.id?.toString() ?? '',
      );
      setTwitterHandle(handle);
    };
    fetchTwitterHandle();
  }, [studioInstance]);

  return twitterHandle;
}

export function useCreatorEnsOrFormattedWalletAddress() {
  const studioInstance = useMainStore((state) => state.studioInstance);
  const [creatorEnsOrFormattedWalletAddress, setCreatorEnsOrFormattedWalletAddress] = useState<
    string | null
  >(null);

  useEffect(() => {
    const fetchCreatorEnsOrFormattedWalletAddress = async () => {
      const resolvedENS = await resolveENSFromBadges(studioInstance?.creator.address ?? '');
      if (!resolvedENS) {
        setCreatorEnsOrFormattedWalletAddress(
          StringUtils.abbreviateAddress(studioInstance?.creator.address ?? ''),
        );
      } else {
        setCreatorEnsOrFormattedWalletAddress(resolvedENS);
      }
    };
    fetchCreatorEnsOrFormattedWalletAddress();
  }, [studioInstance]);

  return creatorEnsOrFormattedWalletAddress;
}
